/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ContactType {
    CALL = 'CALL',
    EMAIL = 'EMAIL',
    INTERNET = 'INTERNET',
    MESSENGER = 'MESSENGER',
    PERSONAL_COMMUNICATION = 'PERSONAL_COMMUNICATION',
    SMS = 'SMS',
    SOCIAL = 'SOCIAL'
}

